const firebaseConfig = {
  apiKey: "AIzaSyAuZtSNZFWG0wxb-oguuusqRuXId346Y7A",
  authDomain: "routeroyalle.firebaseapp.com",
  projectId: "routeroyalle",
  storageBucket: "routeroyalle.firebasestorage.app",
  messagingSenderId: "1078375372206",
  appId: "1:1078375372206:web:c5748194a522343af2e43f",
  measurementId: "G-CZ0J6HSVRP"
};

export default firebaseConfig;

